import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import wsManager from '@/utils/websocket'
import { resetDynamicRoutesFlag } from '@/router/routeRegistry'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    // console.log('response.res',res)
    if (res.code !== 200) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // 未登录或token过期
      if (res.code === 401) {
        resetDynamicRoutesFlag()
        localStorage.removeItem('token')
        localStorage.removeItem('pms')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userMenus')
        wsManager.logout()
        console.log('跳转登录页.')
        router.push('/login')
      }
      return res
    }
    return res
  },
  error => {
    let message = '请求失败'
    if (error.response) {
      const raw = error.response.data
      const data = typeof raw === 'string' ? (() => {
        try { return JSON.parse(raw) } catch (e) { return null }
      })() : raw
      if (data && (data.msg || data.message)) {
        message = data.msg || data.message
      }
      switch (error.response.status) {
        case 400:
          message = (data && (data.msg || data.message)) || message || '请求参数错误'
          break
        case 401:
          message = '登录已过期，请重新登录'
          resetDynamicRoutesFlag()
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('userMenus')
          localStorage.removeItem('pms')
          router.push('/login')
          break
        case 500:
          if (data && (data.msg || data.message)) {
            message = data.msg || data.message
          }
          break
      }
    } else if (error.message) {
      message = error.message
    }
    return { code: error.response && error.response.status === 400 ? 400 : 500, msg: message }
  }
)

export default service